import React from "react";
import SpinnerModal from "../../spiner/SpinnerModal";
import "./SolicitudModal.css";

export default class VincularModal extends React.Component {
    formatMoney = (val) => {
        const n = Number(String(val ?? "").replaceAll(",", "."));
        if (Number.isNaN(n)) return String(val ?? "-");
        return n.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    isUrl = (text) => /^https?:\/\//i.test(String(text || "").trim());
    toUrl = (text) => {
        const raw = String(text || "").trim();
        if (!raw) return "";
        return this.isUrl(raw) ? raw : `https://${raw}`;
    };

    render() {
        const { show, onClose, solicitud, loading, ventasVinculadas, onClickAgregar, onDesvincular } = this.props;
        if (!show) return null;

        const s = solicitud || {};
        const comentariosTxt = String(s.comentarios ?? "").trim();

        const ventas = Array.isArray(ventasVinculadas) && ventasVinculadas.length
            ? ventasVinculadas
            : Array.isArray(s.ventas)
                ? s.ventas
                : [];

        const carpetaRaw = String(s.carpeta ?? "").trim();
        const carpetaUrl = this.toUrl(carpetaRaw);

        return (
            <div className="sm-backdrop">
                <div className="sm-modal" onClick={(e) => e.stopPropagation()}>
                    {loading ? <SpinnerModal show={true} /> : null}

                    <div className="sm-head">
                        <h2 className="sm-title">Vincular ventas</h2>
                        <button className="sm-x" type="button" onClick={onClose} disabled={loading} aria-label="Cerrar">
                            ✕
                        </button>
                    </div>

                    <div className="sm-body">
                        {/* ===== Detalles ===== */}
                        <div className="vm-card">
                            <div className="vm-cardTop">
                                <div className="vm-titleRow">
                                    <div className="vm-kicker " style={{ color: "#000", fontSize: "large", }}>
                                        Ticket:
                                        <span style={{ marginLeft: "5px" }} className={`vm-pill ${Number(s.idestatus) === 1 ? "ok" : "warn"}`}>
                                            {s.estatus || "-"}
                                        </span>
                                    </div>
                                    <div className="vm-title">#{s.idticket || "-"}</div>
                                </div>

                                <div className="vm-chips">

                                    <span className="vm-chip lblfont">
                                        Fecha tránsito: <b className="vm-chipMono">{s.fecha_transito || "-"}</b>
                                    </span>

                                </div>
                            </div>

                            {/* body */}
                            <div className="vm-grid">
                                <div className="vm-item">
                                    <div className="vm-label lblfont">Cliente</div>
                                    <div className="vm-value">{`${s.nombre || ""} ${s.apellido || ""}`.trim() || "-"}</div>
                                </div>

                                <div className="vm-item">
                                    <div className="vm-label lblfont">Locación</div>
                                    <div className="vm-value">{s.locacion || "-"}</div>
                                </div>

                                <div className="vm-item">
                                    <div className="vm-label lblfont">Pasaporte</div>
                                    <div className="vm-value vm-valueMono">{s.pasaporte || "-"}</div>
                                </div>

                                <div className="vm-item">
                                    <div className="vm-label lblfont">Nacionalidad</div>
                                    <div className="vm-value vm-valueMono">{s.nacionalidad || "-"}</div>
                                </div>

                                <div className="vm-item">
                                    <div className="vm-label lblfont">Vía</div>
                                    <div className="vm-value vm-valueMono">{s.via || "-"}</div>
                                </div>

                                <div className="vm-item">
                                    <div className="vm-label lblfont">Monto</div>
                                    <div className="vm-value vm-valueMono">
                                        ${this.formatMoney(s.cantidad)} {s.moneda || ""}
                                    </div>
                                </div>

                                <div className="vm-item">
                                    <div className="vm-label lblfont">Carpeta</div>
                                    <div className="vm-value">


                                        <button
                                            type="button"
                                            className="v-miniBtn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                window.open(carpetaUrl, "_blank", "noopener,noreferrer");
                                            }}
                                            title="Abrir carpeta"
                                        >
                                            Ver
                                        </button>

                                    </div>
                                </div>
                            </div>

                            {/* comentarios */}
                            <div className="vm-note">
                                <div className="vm-noteLabel lblfont">Comentarios</div>
                                <div className="vm-noteText">{comentariosTxt ? comentariosTxt : "— Sin comentarios —"}</div>
                            </div>
                        </div>

                        {/* ===== Header sección ===== */}
                        <div className="vm-sectionHead">
                            <h3 className="vm-h3">Ventas vinculadas</h3>

                            <button
                                type="button"
                                className="v-btn"
                                onClick={onClickAgregar}
                                disabled={loading}
                                title="Agregar venta"
                            >
                                + Agregar
                            </button>
                        </div>

                        {/* ===== Lista vinculadas ===== */}
                        <div className="v-tableWrap rowstile">
                            <table className="v-table">
                                <thead>
                                    <tr>
                                        <th>ID Pago</th>
                                        <th>Ticket</th>
                                        <th>Productos</th>
                                        <th>Locación</th>
                                        <th>Método</th>

                                        <th>Total</th>
                                        <th>Hora</th>
                                        <th>Estatus</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ventas.length === 0 ? (
                                        <tr>
                                            <td colSpan="11" className="v-empty">No hay ventas vinculadas.</td>
                                        </tr>
                                    ) : (
                                        ventas.map((v) => (
                                            <tr key={v.idticketpago}>
                                                <td className="v-mono">{v.idticketpago}</td>
                                                <td className="v-mono">{v.idticket}</td>
                                                <td className="v-mono">{v.productos || "-"}</td>
                                                <td>{v.locacion || "-"}</td>
                                                <td className="v-mono">
                                                    {v.metodo_pago || "-"} {v.ultimos_digitos ? `****${v.ultimos_digitos}` : ""}
                                                </td>

                                                <td className="v-mono">{this.formatMoney(v.total)}</td>
                                                <td className="v-mono">{v.hora || "-"}</td>
                                                <td>{v.estatus || "-"}</td>
                                                <td style={{ whiteSpace: "nowrap" }}>
                                                    <button
                                                        type="button"
                                                        className="v-miniBtn"
                                                        onClick={() => onDesvincular(v)}
                                                        disabled={loading}
                                                    >
                                                        Desvincular
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="sm-foot">
                        <button type="button" className="sm-btn ghost" onClick={onClose} disabled={loading}>
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}